import React, { useState } from 'react';
import './App.css';

function App() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState(null);
  const [prompt, setPrompt] = useState("Example: Organize a birthday party based on this vibe. Budget: $5000. Guests: 50.");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleGenerate = async () => {
    if (!selectedFile) return alert("Please upload an image first!");

    setLoading(true);
    setEventData(null); 

    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("prompt", prompt);

    try {
      const response = await fetch("https://eventsense-hack-with-gemini-1.onrender.com/analyze", {
          method: "POST",
          body: formData,
      });

      const data = await response.json();
      
      if (data.error) {
        alert("Server Error: " + data.error);
      } else {
        setEventData(data);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to connect to backend. Is server.py running?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <header>
        <h1>✨ EventSense AI</h1>
        <p>Turn your Pinterest screenshots into real event plans.</p>
      </header>

      {/* INPUT SECTION */}
      <div className="input-section pixel-shadow">
        <div className="upload-box">
          {imagePreview ? (
            <img src={imagePreview} alt="Preview" className="preview-img" />
          ) : (
            <div className="placeholder">
              <span>📁</span>
              <p>Upload Inspiration Image</p>
            </div>
          )}
          <input type="file" onChange={handleFileChange} accept="image/*" className="file-input" />
        </div>

        <div className="controls">
          <label>Your Request:</label>
          <textarea 
            value={prompt} 
            onChange={(e) => setPrompt(e.target.value)} 
            rows="4"
          />
          <button onClick={handleGenerate} disabled={loading} className="gen-btn">
            {loading ? "🔮 Consulting the AI..." : "🚀 Generate Event Plan"}
          </button>
        </div>
      </div>

      {/* RESULTS SECTION */}
      {eventData && eventData.event_plan && (
        <div className="dashboard fade-in">
          {/* Header Card */}
          <div className="card header-card pixel-shadow">
            <h2>{eventData.event_plan.event_title}</h2>
            <p className="theme-text">"{eventData.event_plan.theme_analysis}"</p>
            <div className="badge">Total Est: ${eventData.event_plan.estimated_total_cost}</div>
          </div>

          <div className="grid">
            {/* Decor */}
            <div className="card pixel-shadow">
              <h3>🎨 Decor Strategy</h3>
              <p style={{whiteSpace: 'pre-line'}}>{eventData.event_plan.decor_plan}</p>
            </div>

            {/* Agenda */}
            <div className="card pixel-shadow">
              <h3>🕒 Run of Show</h3>
              <p style={{whiteSpace: 'pre-line'}}>{eventData.event_plan.agenda}</p>
            </div>

            {/* Poster */}
            <div className="card pixel-shadow">
              <h3>📢 Marketing / Poster</h3>
              <p><strong>Headline:</strong> {eventData.poster.headline}</p>
              <p><strong>Palette:</strong> {eventData.poster.color_palette}</p>
              <p className="small-text">Visual Prompt: {eventData.poster.visual_style_prompt}</p>
            </div>

            {/* Menu */}
            <div className="card pixel-shadow">
              <h3>🍽️ Menu: {eventData.menu.cuisine}</h3>
              <p><em>{eventData.menu.menu_aesthetic}</em></p>
              <ul>
                {eventData.menu.items.map((item, idx) => (
                  <li key={idx}><strong>{item.name}</strong>: {item.description}</li>
                ))}
              </ul>
              <div className="badge small">Food Budget: ${eventData.menu.catering_budget_estimate}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
